import { openBlock, createElementBlock, createVNode } from "vue";
import ArrowIcon from "./ArrowIcon.vue.es.js";
/* empty css                 */
import _export_sfc from "../uikit._virtual/_plugin-vue_export-helper.es.js";
const _hoisted_1 = { class: "back-icon" };
const _sfc_main = {
  __name: "BackIcon",
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [
        createVNode(ArrowIcon, {
          type: "left",
          gradient: "no-gradient"
        })
      ]);
    };
  }
};
const BackIcon = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-e5d9a4b0"]]);
export {
  BackIcon as default
};
//# sourceMappingURL=BackIcon.vue.es.js.map
